import { SlashIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../constants/colors.mjs';
import { factory } from '../../factory/factory.utils.mjs';
import { Typography } from '../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../Layout/Flex/Flex.mjs';
import classes from './CarouselCounter.module.css.mjs';

const CarouselCounter = factory((props, ref) => {
  const { current, total, className, ...rest } = props;
  const classNames = clsx("kohler-carousel-counter-root", className);
  return /* @__PURE__ */ React.createElement(Flex, { align: "center", className: classNames, ref, ...rest }, /* @__PURE__ */ React.createElement(Typography, { textColor: DsmColor.ContentPrimary, component: "span", size: "h5", className: "kohler-carousel-counter-current" }, current), /* @__PURE__ */ React.createElement(SlashIcon, { size: "large", withBoundingBox: true, className: clsx(classes.slashIcon, "kohler-carousel-counter-slash") }), /* @__PURE__ */ React.createElement(Typography, { component: "span", size: "h5", textColor: DsmColor.ContentTertiary, className: "kohler-carousel-counter-total" }, total));
});

export { CarouselCounter };
